module.exports = "/_next/static/images/delivery_icon-0d548ba683ec4f8e7384d9514cb4b7ec.svg";